import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstanceAttachmentFields } from "../Entity/TreeNodeSubstanceAttachmentFields";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceAttachmentFieldsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Substance Attachments ({param})');
      this.parent = parent;
      this.labelNodeName = 'Substance Attachments';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstanceAttachmentFields(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let substanceattachments: Art57Node[] = [];
      this.children?.forEach((node) => {
        let substanceattachment = node as Art57Node;
        substanceattachments.push(substanceattachment.getMessage());
      });
  
      if (substanceattachments.length > 0) {
        return {
          substanceattachments: { substanceattachment: substanceattachments },
        };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Substance Attachment', 'Validity Declaration'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceAttachmentFieldsList =
        new TreeNodeSubstanceAttachmentFieldsList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }